import apiFetch from '../apiFetch'

export default function (token, paperworkTypeId) {
  return apiFetch({ endPoint: `paperworkType/Master/Delete?paperworkTypeId=${paperworkTypeId}`, method: 'DELETE', body: null, token: token })
}
